<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8">
        <section v-if="news" class="news-container">
          <div class="bread-crumb">
            <p class="bread-crumb-items">
              <i class="fas fa-home"></i>
              <i class="far fa-chevron-right"></i>
              <b-link class="bread-crumb-link" :to="news.categoryUrl">
                {{ news.categoryName }}
              </b-link>
            </p>
          </div>
          <h1 class="news-title">{{ news.title }}</h1>
          <p class="news-tools">
            <i class="add-time far fa-calendar-alt"></i> {{ news.addTimeMMddyyyyHHmm }}
            <social-sharing
              class="share-links"
              :url="'https://www.qazlatyn.kz/article?id=' + $route.query.id"
              :title="news.title"
              :description="news.shortContent"
              :quote="news.title"
              :hashtags="news.title"
              :media="host + '/images/top_bg.png'"
              v-cloak
              inline-template>
              <div>
                <network class="share-link facebook" network="facebook" id="facebook">
                  <i class="fab fa-facebook-square"></i>
                </network>
                <network class="share-link google-plus" network="googleplus" id="googleplus">
                  <i class="fab fa-google-plus-square"></i>
                </network>
                <network class="share-link telegram" network="telegram" id="telegram">
                  <i class="fab fa-telegram"></i>
                </network>
                <network class="share-link twitter" network="twitter" id="twitter">
                  <i class="fab fa-twitter-square"></i>
                </network>
                <network class="share-link vk" network="vk" id="vk">
                  <i class="vk fab fa-vk"></i>
                </network>
                <network class="share-link whatsapp" network="whatsapp" id="whatsapp">
                  <i class="fab fa-whatsapp"></i>
                </network>
              </div>
            </social-sharing>
            <!-- <span class="share-links">
              <span @click="shareFacebook" class="share-link facebook">
                <i class="fab fa-facebook-square"></i>
              </span>
              <span :href="shareWhatsapp" class="share-link whatsapp">
                <i class="fab fa-whatsapp"></i>
              </span>
              <span @click="shareTelegram" class="share-link telegram">
                <i class="fab fa-telegram"></i>
              </span>
              <span @click="shareTwitter" class="share-link twitter">
                <i class="fab fa-twitter-square"></i>
              </span>
              <span @click="shareVk" class="share-link vk">
                <i class="vk fab fa-vk"></i>
              </span>
              <span @click="shareGooglePlus" class="share-link google-plus">
                <i class="fab fa-google-plus-square"></i>
              </span>
            </span> -->
          </p>
          <div v-if="news.thumbnailUrl !== undefined" class="news-thumbnail">
            <img class="news-img" :src="bigThumnailUrl(host + news.thumbnailUrl)" :alt="news.title">
          </div>
          <article v-if="news.fullContent !== undefined" v-html="replaceImage(news.fullContent)" class="news-content"></article>
          <!-- <div class="show-news-ad">
            <a href="/ads/show/9.html">
              <img class="ad" :src="host + '/ads/show/9.png'" alt="">
            </a>
          </div> -->
          <div class="news-tag-list" v-if="news.tagList !== undefined && news.tagList.length > 0">
            <span class="news-tag-icon"><i class="fal fa-tags"></i></span>
            <b-link
              :to="linkPrefix + tag.url"
              v-for="(tag, index) in news.tagList"
              :key="index"
              class="news-tag-item">
              {{ tag.tagTitle }} <span class="badge badge-light">{{ tag.taggedCount }}</span>
            </b-link>
          </div>
        </section>
      </b-col>
      <b-col cols="4">
        <side-bar></side-bar>
        <div class="shownews-sidebar">
          <a href="/ads/show/9.html" target="_blank">
            <img class="ad" :src="host + '/ads/show/9.png'" alt="">
          </a>
        </div>
      </b-col>
    </b-row>
    <div v-show="showImageList" class="news-image-viewer" @click="hideImageList">
      <div class="image-container">
        <img :src="host + newsImageList[newsImageIndex]" alt="News Images">
        <div class="image-control">
          <div class="prev-icon control-icon" @click="newImageSlide(-1)">
            <i class="fal fa-arrow-circle-left control-icon"></i>
          </div>
          <div class="next-icon control-icon" @click="newImageSlide(1)">
            <i class="fal fa-arrow-circle-right control-icon"></i>
          </div>
        </div>
        <div class="image-thumbs">
          <div
            class="thumb-item"
            v-for="(item, index) in newsImageList"
            :key="index"
            :style="{
              'background-color': newsImageIndex === index ? '#008496' : '#ffffff'
            }"></div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import SideBar from "@/components/home/SideBar.vue";
export default {
  data() {
    return {
      newsUrl: this.$route.fullPath,
      news: {},
      showImageList: false,
      newsImageIndex: 0
    };
  },

  computed: {
    linkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },
    host() {
      return this.$store.state.host;
    },
    newsImageList() {
      let imageList = [];
      if (this.news.fullContent && this.news.fullContent.indexOf("<img ") > 0) {
        let pattern = /(\/uploads\/[A-Za-z0-9\.\/]+[jpg|png|jpeg|bmp|gif])/g;
        imageList = this.news.fullContent.match(pattern) || [];
        if (this.news.thumbnailUrl !== undefined) {
          imageList.unshift(this.bigThumnailUrl(this.news.thumbnailUrl));
        }
      } else {
        if (this.news.thumbnailUrl){
          imageList.push(this.bigThumnailUrl(this.news.thumbnailUrl));
        }
      }
      return imageList;
    }
  },

  created() {
    this.getNewsById(this.$route.query.id);
  },

  mounted() {
    document.addEventListener("click", e => {
      e = e ? e : window.event;
      let targetEl = e.srcElement ? e.srcElement : e.target;
      if (
        targetEl.tagName === "IMG"
        && targetEl.classList.toString().includes("news-img")
      ) {
        this.showImageList = true;
      }
    });
  },

  methods: {
    hideImageList(e) {
      e = e ? e : window.event;
      let targetEl = e.srcElement ? e.srcElement : e.target;
      if (!targetEl.classList.toString().includes("control-icon")) {
        this.showImageList = false;
      }
    },
    newImageSlide(direction) {
      if (this.newsImageList.length === 1) return;
      // direction -1 prev || 1 next
      if (direction > 0 && this.newsImageIndex === this.newsImageList.length - 1) this.newsImageIndex = 0;
      else if (direction < 0 && this.newsImageIndex === 0) this.newsImageIndex = this.newsImageList.length - 1;
      else this.newsImageIndex  = this.newsImageIndex + direction;
    },
    bigThumnailUrl(stringUrl) {
      return stringUrl.replace("_small.", "_big.");
    },
    replaceImage(content) {
      return content.replace(/\/uploads\//ig, this.host + "/uploads/")
        .replace(/\.\spng/ig, ".png")
        .replace(/. jpg/ig, ".jpg")
        .replace(/. jpeg/ig, ".jpeg")
        .replace(/<img/ig, "<img class='news-img' ");
    },
    getNewsById(id) {
      this.$store.state.loading = true;
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("id", id);
      this.$http
        .post(this.host + "/api/qazlatyn/getarticle", fd)
        .then(result => {
          this.$store.state.loading = false;
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.news = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    shareFacebook() {
      let targetUrl = "http://www.facebook.com/share.php?u=";
      let currentUrl = this.$route.fullPath;
      let style = `
        height=500,
        width=650,
        top=0,
        left=0,
        toolbar=no,
        menubar=no,
        scrollbars=no,
        resizable=no,
        location=no,
        status=no
      `;
      window.open(targetUrl + currentUrl, "", style);
    },

    shareWhatsapp() {
      let targetUrl = "whatsapp://send?text=";
      let currentUrl = this.$route.fullPath;
      return targetUrl + this.news.title + currentUrl;
    },

    shareTelegram() {
      let targetUrl = "https://telegram.me/share/url?url=";
      let currentUrl = this.$route.fullPath;
      let title = this.news.title;
      let style = `
        height=500,
        width=650,
        top=0,
        left=0,
        toolbar=no,
        menubar=no,
        scrollbars=no,
        resizable=no,
        location=no,
        status=no
      `;
      window.open(targetUrl + currentUrl + "&text=" + title, "", style);
    },

    shareTwitter() {
      let targetUrl = "http://twitter.com/home/?status=";
      let currentUrl = this.$route.fullPath;
      let title = this.news.title;
      let style = `
        height=500,
        width=650,
        top=0,
        left=0,
        toolbar=no,
        menubar=no,
        scrollbars=no,
        resizable=no,
        location=no,
        status=no
      `;
      window.open(targetUrl + title + currentUrl, "", style);
    },

    shareVk() {
      let targetUrl = "http://vk.com/share.php?url=";
      let title = this.news.title;
      let description = this.news.shortContent;
      let style = `
        height=500,
        width=650,
        top=0,
        left=0,
        toolbar=no,
        menubar=no,
        scrollbars=no,
        resizable=no,
        location=no,
        status=no
      `;
      window.open(
        targetUrl +
          "&title=" +
          title +
          "&description=" +
          description +
          "&imageurl=" +
          this.news.thumbnailUrl,
        "",
        style
      );
    },

    shareGooglePlus() {
      let targetUrl = "https://plus.google.com/share?url=";
      let currentUrl = this.$route.fullPath;
      let style = `
        height=500,
        width=650,
        top=0,
        left=0,
        toolbar=no,
        menubar=no,
        scrollbars=no,
        resizable=no,
        location=no,
        status=no
      `;
      window.open(targetUrl + currentUrl, "", style);
    }
  },

  watch: {
    $route(newVal, oldVal) {
      if (oldVal.query.id !== newVal.query.id) {
        this.getNewsById(newVal.query.id);
      }
      if (oldVal.params.ln !== newVal.params.ln) {
        this.getNewsById(newVal.query.id);
      }
    }
  },

  components: {
    "side-bar": SideBar
  },

  metaInfo() {
    return {
      title: this.news.title
    };
  }
};
</script>

<style lang="scss">
.news-image-viewer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background-color: #000000cc;

  .image-container {
    position: relative;

    &:hover {
      img {
        transform: scale(1);
      }
    }

    img {
      width: 1100px;
      transform: scale(0.85);
      transition: all 0.5s ease-in-out;
    }

    .image-control {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        .prev-icon,
        .next-icon {
          opacity: 1;
          background-image: radial-gradient(circle, #038395dd 10%, #03839522 40%, #03839500 100%);
        }
      }

      .prev-icon,
      .next-icon {
        width: 100px;
        height: 100%;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 1s ease-in-out;
        font-size: 28px;
        color: #ffffff;

        // &:hover {
        //   opacity: 1;
        //   background-image: radial-gradient(circle, #038395dd 10%, #03839522 40%, #03839500 100%);
        // }
      }
    }

    .image-thumbs {
      height: 60px;
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;

      .thumb-item {
        width: 50px;
        height: 5px;
        background-color: #ffffff;
        margin-right: 10px;
      }
    }
  }
}
.news-container {
  background-color: #ffffff;
  border: 1px solid #ededed;
  border-radius: 0.125rem;
  padding: 1rem;

  .bread-crumb {
    .bread-crumb-items {
      color: #959596;
      font-size: 0.875rem;

      i {
        margin-right: 0.25rem;
      }
    }
  }

  .news-title {
    color: #212525;
    margin-bottom: 14px;
    font-size: 32px;
  }

  .news-tools {
    color: #231f20;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.75rem;

    .add-time {
      color: #038395;
      font-size: 1rem;
      margin-right: 0.5rem;
    }

    .news-tool-devider {
      font-size: 0.625rem;
      margin-left: 0.625rem;
      margin-right: 0.625rem;
    }

    .share-links {
      display: inline-block;
      margin-right: 1rem;
      margin-left: 1rem;

      .share-link {
        display: inline-block;
        cursor: pointer;
        height: 1rem;
        width: 1rem;
        margin-right: 0.25rem;
        margin-left: 0.25rem;

        i {
          font-size: 1.125rem;
        }
      }

      .facebook {
        color: #3460ad;

        &:hover {
          color: #3477ec;
        }
      }

      .whatsapp {
        color: #44b85c;

        &:hover {
          color: #59f578;
        }
      }

      .telegram {
        color: #22badb;

        &:hover {
          color: #47ddff;
        }
      }

      .twitter {
        color: #39bded;

        &:hover {
          color: #77ceee;
        }
      }

      .vk {
        color: #3771a7;

        &:hover {
          color: #5eadf7;
        }
      }

      .google-plus {
        color: #de1f26;

        &:hover {
          color: #f5545a;
        }
      }
    }
  }

  .news-thumbnail {
    margin-bottom: 1rem;

    img {
      width: 100%;
    }
  }

  .news-content,
  .news-content * {
    color: #333;
    text-indent: 1rem;
    font-size: 17px;
    line-height: 1.6;
  }

  .news-content {
    img[style*="left"] {
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    img[style*="right"] {
      margin-left: 1rem;
      margin-bottom: 1rem;
    }
    * {
      text-indent: 1rem;
    }
  }

  .news-tag-list {
    margin-top: 20px;

    .news-tag-icon {
      font-size: 1.25rem;
      color: #777777;
      font-weight: bold;
      margin-right: 0.25rem;
    }
    .news-tag-item {
      padding: 0.125rem 1rem 0.25rem;
      background: #959696;
      color: #ffffff;
      margin: 0.25rem;
      border-radius: 0.25rem;
      text-decoration: none;
      
      &:hover {
        background: #777777;

        .badge {
          color: #777777;
        }
      }

      .badge {
        margin-right: -0.25rem;
        color: darken(#959696, 0.5);
      }
    }
  }
}
.show-news-ad {
  padding: 10px;

  .ad {
    width: 100%;
  }
}
.shownews-sidebar {
  margin-top: 1rem;
  background-color: #ffffff;
  padding: 1rem;

  img {
    width: 100%;
  }
}
.bread-crumb-link {
  color: #959696 !important;

  &:hover {
    color: #3477ec !important;
  }
}

/* RTL */

.rtl-layout .news-container {
  .bread-crumb-items {
    direction: rtl;
    text-align: right;

    .fa-chevron-right {
      transform: rotate(180deg);
    }
  }

  .news-title,
  .news-tools {
    direction: rtl;
    text-align: right;
  }
  
  .news-content {
    direction: rtl;
    text-align: right !important;
  }

  .news-tag-list {
    direction: rtl;
    text-align: right;

    .news-tag-icon {
      margin-right: 0 !important;
      margin-left: 4px;

      i {
        transform: rotate(90deg);
      }
    }
  }
}
</style>

<style>
.news-content p {
  margin-bottom: 20px !important;
  font-size: 17px;
  color: #333333;
  line-height: 1.5;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  text-align: left;
}
.news-content img {
  max-width: 100% !important;
  height: auto !important;
}

.news-content iframe {
  min-width: 80% !important;
  min-height: 80% !important;
  max-width: 100%;
}
.share-links {
  display: inline-block;
  margin-right: 1rem;
  margin-left: 1rem;
}
.share-links .share-link {
  display: inline-block;
  cursor: pointer;
  height: 1rem;
  width: 1rem;
  margin-right: 6px;
  margin-left: 6px;
}
.share-links .share-link i {
  font-size: 1.125rem;
}

.share-links .facebook {
  color: #3460ad;
}
.share-links .facebook:hover {
  color: #3477ec;
}

.share-links .whatsapp {
  color: #44b85c;
}
.share-links .whatsapp:hover {
  color: #59f578;
}

.share-links .telegram {
  color: #22badb;
}
.share-links .telegram:hover {
  color: #47ddff;
}

.share-links .twitter {
  color: #39bded;
}
.share-links .twitter:hover {
  color: #77ceee;
}

.share-links .vk {
  color: #3771a7;
}
.share-links .vk:hover {
  color: #5eadf7;
}

.share-links .google-plus {
  color: #de1f26;
}
.share-links .google-plus:hover {
  color: #f5545a;
}
</style>
